import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from 'app/shared/model';
import { UtilService } from 'app/shared/util.service';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare var hbspt: any

const PREFILL_TIMEOUT_MS = 3000;
const PREFILL_RETRY_MS = 100;
const PREFILL_FIELDS = ['problema_reportado', 'detalles_ajustes_y_configuraciones', 'subject', 'content'];

type FormField = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

function setFieldValue(field: FormField, value: string) {
  const valueSetter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(field), 'value')?.set;
  valueSetter ? valueSetter.call(field, value) : (field.value = value);
  field.dispatchEvent(new Event('input', { bubbles: true }));
  field.dispatchEvent(new Event('change', { bubbles: true }));
}

function applyPrefill(form: HTMLFormElement, prefill: Record<string, string>) {
  let pending = Object.entries(prefill);
  const startedAt = Date.now();
  const tryApply = () => {
    pending = pending.filter(([name, value]) => {
      const field = form.elements.namedItem(name) as FormField;
      if (!field) return true;
      setFieldValue(field, value);
      return false;
    });
    if (pending.length && Date.now() - startedAt < PREFILL_TIMEOUT_MS) {
      setTimeout(tryApply, PREFILL_RETRY_MS);
    }
  };
  tryApply();
}

@Component({
    selector: 'mh-hubspot-support',
    templateUrl: './hubspot-support.component.html',
    styleUrls: ['./hubspot-support.component.scss'],
    standalone: false
})
export class HubspotSupportComponent implements OnInit {

  public showResetButton: boolean = false;
  public currentLang: string;
  public sub: Subscription;
  public labelsTranslations: any;
  public LANG_FORM_ID = {
    'es': environment.hubspotFormIdEs,
    'en': environment.hubspotFormIdEn,
    'pt': environment.hubspotFormIdPt
  };

  private prefill: Record<string, string>;

  constructor(private utilService: UtilService, private translate: TranslateService, private route: ActivatedRoute) {
    const queryParams = this.route.snapshot.queryParams;
    this.prefill = Object.fromEntries(
      PREFILL_FIELDS.filter((field) => typeof queryParams[field] === 'string').map((field) => [field, queryParams[field]]),
    );
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.sub = this.utilService.isLanguageChanged().subscribe(response=>{
      this.currentLang = response;
      this.createHubspotForm(this.user, this.currentLang).then(() => this.showResetButton = true);
    });
    this.createHubspotForm(this.user, this.language).then(() => this.showResetButton = true);
  }

  createHubspotForm(user: User, language: string, prefill: Record<string, string> = this.prefill) {
    const translateService = this.translate;
    const langFormIdRef = this.LANG_FORM_ID;

    return new Promise(function (resolve, reject) {
      translateService.get([
        'support.send_form'
      ]).subscribe(res => {
        const sendTranslation = res['support.send_form'];
        hbspt.forms.create({
          region: environment.hubspotRegion,
          portalId: environment.hubspotPortalId,
          formId: langFormIdRef[language],
          target: "#hubspotForm",
          locale: language === 'pt' ? 'pt-br' : language,
          translations: {
            en: {
              submitText: sendTranslation
            },
            pt: {
              submitText: sendTranslation
            }
          },
          onFormReady($form){
            let emailInput;
            [...$form[0].elements].forEach(element => {
              if(element.name === 'email') emailInput = element;
            });
            emailInput.value = user.email;
            emailInput.dispatchEvent(new Event('input', { bubbles: true }));
            applyPrefill($form[0], prefill);
          },
          onFormSubmitted() {
            resolve(true);
          }
        });
      })
    });
  }

  resetForm() {
    this.showResetButton = false;
    this.createHubspotForm(this.user, this.language, {});
  }

  get user() {
    return this.utilService.getCurrentUser();
  }
  get language() {
    return this.currentLang ? this.currentLang : this.utilService.getCurrentLanguage();
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }
  
}
